"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlertsStore = void 0;
const pinia_1 = require("pinia");
const get_1 = __importDefault(require("lodash/get"));
;
exports.useAlertsStore = (0, pinia_1.defineStore)('alerts', {
    state: () => {
        return {
            alerts: [],
            timeouts: {},
        };
    },
    actions: {
        add(alert) {
            if (!alert.time) {
                alert.time = 10000;
            }
            if (this.timeouts[alert.key]) {
                window.clearTimeout(this.timeouts[alert.key]);
            }
            this.remove(alert.key);
            this.alerts.push(alert);
            this.timeouts[alert.key] = window.setTimeout(() => {
                this.remove(alert.key);
                delete this.timeouts[alert.key];
            }, alert.time);
        },
        clear() {
            this.alerts = [];
        },
        remove(key) {
            this.alerts = this.alerts.filter((alert) => {
                return (0, get_1.default)(alert, 'key') !== key;
            });
        }
    }
});
